
export class DropZoneStyle {
  // Default colours
  private defaultIdleColor: number[];
  private defaultHoverColor: number[];
  private defaultRejectedColor: number[];
  private currentElementColour: number[];
  private transitionTime: number;

  // Entry point
  constructor() {
    this.defaultIdleColor = [255, 255, 255];
    this.defaultHoverColor = [187, 215, 252];
    this.defaultRejectedColor = [255, 191, 191];
    this.currentElementColour = this.defaultIdleColor;
    this.transitionTime = 0.5;
  }

   /*
  // Called when a hover starts
  public onHoverStart() {
  }

  // Called when a hover ends
  public onHoverEnd() {
  }
  */

  // Called when a file is rejected
  public onFileRejected() {
    // Slightly different, we flash fail and fade out
    this.currentElementColour = this.defaultRejectedColor;
  }

  // Called when a file is accepted
  public onFileAccepted() {
    // We won't do anything with this by default
  }

  // Converts a single RGB colour component to hex
  componentToHex(component: number): string {
    // Found it first, we don't deal with non-integer values
    component = Math.round(component);
    const hex = component.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }

}
